/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import Access from 'constants/Access';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './constants/Routes';
import LoginPage from './flows/base/pages/login';
import ForgotPasswordPage from './flows/base/pages/forgot_password';
import ChangePasswordPage from './flows/base/pages/change_password/';
import Test1Page from './flows/base/pages/test1';
import Test2Page from './flows/base/pages/test2';
import HomePage from './flows/base/pages/home';
//import ListPage from './flows/quotation/pages/list';
import ListPage2 from './flows/quotation/pages/list2';
import PrivateRoute from 'components/PrivateRoute';
import { QuotationRoutes } from './flows/quotation/pages/list/constants';

import QuoteEditPageV2 from './flows/quotation/pages/edit_v2';
import QuoteAddPage from './flows/quotation/pages/add';
import EditEnquirity from 'flows/quotation/pages/edit_v2';
import BasePage from './flows/quotation/pages/base';
import ClaimPage from './flows/quotation/pages/claims';
import EditClaim from './flows/quotation/pages/claimsForm';
import ClaimComposition from './flows/quotation/pages/claimComposition';
import ClaimFDO from './flows/quotation/pages/claimFDO';
import PolicyPage from './flows/quotation/pages/policiesAndEndorsements';
import PaymentPageV2 from './flows/quotation/pages/payment_v2';
import RenewPage from './flows/quotation/pages/renew';
import Person from './flows/base/pages/person';
import ManagementPage from './flows/quotation/pages/management';
import editPerson from './flows/base/pages/edit_person';
import ProductPlanPerson from './flows/base/pages/product_plan_person';
import EditProductPlan from './flows/base/pages/edit_product_plan';
import Products from './flows/base/pages/products';
import EditProduct from './flows/base/pages/edit_product';
import ImportCurrencyRate from './flows/base/pages/import_currency_rate';

//BROKING
import NbiRequest from './flows/broking/pages/nbiRequest';
import ApprovalNbi from './flows/broking/pages/nbiApproval';
import SelectMarkets from './flows/broking/pages/selectMarkets';
import ContactSelection from './flows/broking/pages/contactsSelection';
import SendNbiRequest from './flows/broking/pages/sendNbiRequest';
import ReSendNbiRequest from './flows/broking/pages/resendNbi';
import MarketManagement from './flows/broking/pages/MarketManagement';
import DocumentManagement from './flows/broking/pages/documentManagementv2';
import NbiRequestCv from 'flows/broking/pages/nbiRequestCv';
import NbiApprovalCv from 'flows/broking/pages/nbiApprovalCv';
import NbiDocStatus from 'flows/broking/pages/nbiDocStatus';
import ApprovedNbi from 'flows/broking/pages/approvedNbi';
import ScheduleInitialExport from 'flows/broking/pages/scheduleExport';
import MarketComposition from 'flows/broking/pages/marketComposition';
import marketCompositionOld from 'flows/broking/pages/marketCompositionOld';
import MrcComplementaryInformation from 'flows/broking/pages/mrcComplementaryInformation';
import SendMrcRequest from 'flows/broking/pages/sendMrcRequest';
import SendNbi from 'flows/broking/pages/sendNBI';
import ScheduleExibition from 'flows/broking/pages/scheduleExibition';
import PolicyPackApprovalList from 'flows/broking/pages/policyPackApprovalList';
import SendPolicyPackClient from 'flows/broking/pages/sendPolicyPackClient';
import SendApprovalPolicyPack from 'flows/broking/pages/sendApprovalPolicyPack';
import ApprovalPolicyPack from 'flows/broking/pages/approvalPolicyPack';
import WordingRequest from 'flows/broking/pages/wordingRequest';
import SendApprovalPolicyPackDeclaration from 'flows/broking/pages/SendApprovalPolicyPackDeclaration';
import WordingApproval from 'flows/broking/pages/wordingApproval';
import SendPolicyPackInsurer from 'flows/broking/pages/sendPolicyPackInsurer';
import StampStatusList from 'flows/broking/pages/stampsStatusList';
import StampRequestContacts from 'flows/broking/pages/stampsRequestContacts';
import SendOrderToBind from 'flows/broking/pages/sendOrderToBind';
import OrderToBind from 'flows/broking/pages/orderToBind';
import PaymentConfiguration from 'flows/broking/pages/paymentConfiguration';
import SendInvoice from 'flows/broking/pages/sendInvoice';
import SendPolicyPackDirectorApproval from 'flows/broking/pages/sendPolicyPackDirectorApproval';
import SendPolicyPackDirector from 'flows/broking/pages/sendPolicyPackDirector';
import PolicyPackDirectorApproval from 'flows/broking/pages/policyPackDirectorApproval';
import ApprovalInvoice from 'flows/broking/pages/approvalInvoice';
import SendPaymentPackInsurerClient from 'flows/broking/pages/sendPaymentPack';
import SendPaymentPackInsurerClientLegacy from 'flows/broking/pages/sendPaymentPackLegacy';

import PaymentPackSummaryDistribution from 'flows/broking/pages/paymentPackSummaryDistribution';
import EndorsementOffRiskContactsSelection from 'flows/broking/pages/contactSelectionEndorsement';
import SendEndorsementOffRisk from 'flows/broking/pages/sendEndorsementOffRisk';
import ApprovalEndorsementOffRisk from 'flows/broking/pages/approvalEndorsementOffRisk';
import BoundEndorsementOffRisk from 'flows/broking/pages/boundEndorsementOffRisk'
import ContactSelectionNotPreAgreed from 'flows/broking/pages/contactSelectionNotPreAgreedInsurer';
import EndorsementNotPreAgreed from 'flows/broking/pages/endorsementNotPreAgreed'
import SendInvoiceNotPreAgreed from 'flows/broking/pages/sendInvoiceNotPreAgreed';
import SendPaymentPackInsurerClientNotPreAgreed from 'flows/broking/pages/sendPaymentPackNotPreAgreed';
import ApprovalInvoiceNotPreAgreed from 'flows/broking/pages/approvalInvoiceNotPreAgreed';
import SendEndorsementPackRiskMktChanges from 'flows/broking/pages/sendEndorsementPackRiskMktChanges';
import EndorsementDocumentEdit from 'flows/broking/pages/EndorsementDocumentEdit';
import BoundEndorsementPolicyExtension from 'flows/broking/pages/boundEndorsementPolicyExtension'
import NotificationProxy from 'flows/base/pages/notification-proxy'

//Master policy
import SelectMarketsMasterPolicy from 'flows/broking/pages/selectMarketsMasterPolicy';
import ApprovalEndorsementPackAdjustmentsCorrections from 'flows/broking/pages/approvalEndorsementPackAdjustmentsCorrections';
import GenerateEndorsementPackRiskMarketChanges from 'flows/broking/pages/generateEndorsementPackRiskMarketChanges';
import ApprovalEndorsementPackClientChange from 'flows/broking/pages/approvalEndorsementPackClientChange';

import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { ToastContainer } from 'react-toastify';
import Crypt from 'utils/src/crypt';
import useBackgroundOsndImportService from './services/osnd-import-service';
import SecurityCode from "./flows/base/pages/security_code";
import { ReportExportService } from '@fitinsur/components';
import ContractBuilder from 'flows/broking/pages/contractBuilder/index';
import SentToXis from 'flows/broking/pages/sentToXis/index';
import ProcessAdmin from 'flows/quotation/pages/processAdmin/index';

//Process Admin Components
import ProcessAdminPerson from 'flows/base/pages/edit_person_v2';

const App = () => {

  const [loading, setLoading] = React.useState(false);
  const crypt = new Crypt();
  const loadingState = {
    active: (loading),
    toggle: () => setLoading(!loading),
    start: () => setLoading(true),
    stop: () => setLoading(false)
  };

  const authState =
    JSON.parse(localStorage.getItem('fitinsur-session')) && JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-texel'] ?
      crypt.isValidToken(crypt.parseJwt(crypt.decryptJson(JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-texel']).token).exp)
        ? crypt.decryptJson(JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-texel']) : {
          status: false,
          username: "",
          token: "",
          person_product: [],
          user_region: "",
          firstLogin: false,
          changedPassword: false,
          forgotPassword: false
        } : {
        status: false,
        username: "",
        token: "",
        person_product: [],
        user_region: "",
        firstLogin: false,
        changedPassword: false,
        forgotPassword: false
      };

  useBackgroundOsndImportService()

  return (

    <GlobalLoaderContext.Provider value={loadingState}>
      <ReportExportService>
        <ToastContainer newestOnTop />
        <Router basename={process.env.PUBLIC_URL}>

          <Switch>

            <Route path={Routes.LOGIN} component={LoginPage} />

            <Route path={Routes.SECURITY_CODE} component={SecurityCode} />

            <Route path={Routes.FORGOTPASSWORD} component={ForgotPasswordPage} />

            <Route path={Routes.CHANGEPASSWORD} component={ChangePasswordPage} />

            {/*****  BROKING ROUTES *****/}

            <PrivateRoute isAuthenticated={authState.status} path={Routes.NOTIFICATION_PROXY} component={NotificationProxy} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.PERSONREGISTER} component={Person} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CREATEMASTERPOLICY} component={QuoteEditPageV2} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.EDITMASTERPOLICY} component={QuoteEditPageV2} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.ADJUSTMENTS_CORRECTIONS_EDIT} component={ApprovalEndorsementPackAdjustmentsCorrections} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.NOT_PRE_AGREED_EDIT} component={EndorsementDocumentEdit} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.OFF_RISK_EDIT} component={EndorsementDocumentEdit} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CANCELLATION_EDIT} component={EndorsementDocumentEdit} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.RISK_MARKET_CHANGES_EDIT}
              component={GenerateEndorsementPackRiskMarketChanges}
              routePermissions={Access.MARKET_COMPOSITION}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SEND_ENDORSEMENT_PACK_MKT_CHANGES} component={SendEndorsementPackRiskMktChanges} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.POLICY_EXTENSION_EDIT} component={EndorsementDocumentEdit} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CLIENT_CHANGE_EDIT} component={ApprovalEndorsementPackClientChange} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.STAMPSSTATUSLIST}
              component={StampStatusList}
              routePermissions={{
                ...Access.STAMPS_REQUEST,
                ...Access.MARKET_COMPOSITION,
                ...Access.PAYMENT_PACK,
              }}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.APPROVALWORDING} component={WordingApproval} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.APPROVALWORDINGCV} component={WordingApproval} />

            <PrivateRoute
              routePermissions={Access.SEND_WORDING}
              isAuthenticated={authState.status}
              path={Routes.SENDWORDINGREQUEST}
              component={WordingRequest}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.POLICYPACKDECLARATION}
              component={SendApprovalPolicyPackDeclaration}
              routePermissions={{
                ...Access.MARKET_COMPOSITION,
                ...Access.SEND_POLICY_PACK_INTERNALLY,
              }}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SCHEDULEEXPORT} component={ScheduleInitialExport} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.MARKETMANAGEMENT}
              component={MarketManagement}
              routePermissions={Access.MARKET_SELECTION}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENDNBIREQUEST}
              component={SendNbiRequest}
              routePermissions={Access.MARKET_SELECTION}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.RESENDNBIREQUEST}
              component={ReSendNbiRequest}
              routePermissions={Access.MARKET_SELECTION}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SELECTMARKETSMASTERPOLICY} component={SelectMarketsMasterPolicy} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SELECTMARKETS} component={SelectMarkets} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.APPROVALNBI} component={ApprovalNbi} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.APPROVALNBICLIENT}
              component={NbiApprovalCv}
              routePermissions={Access.APPROVAL_NBI}
            />

            {/*   <PrivateRoute isAuthenticated={authState.status} path={Routes.APPROVALNBICLIENT} component={ApprovalNbi} /> */}

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENDPAYMENTPACK}
              component={SendPaymentPackInsurerClient}
              routePermissions={Access.PAYMENT_PACK}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENDPAYMENTPACKLEGACY}
              component={SendPaymentPackInsurerClientLegacy}
              routePermissions={Access.PAYMENT_PACK}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.PAYMENT_PACK_SUMMARY_DISTRIBUTION}
              component={PaymentPackSummaryDistribution}
              routePermissions={Access.PAYMENT_PACK}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SENDPAYMENTPACKNOTPREAGREED} component={SendPaymentPackInsurerClientNotPreAgreed} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.DOCUMENTNBISTATUS}
              component={NbiDocStatus}
              routePermissions={{
                ...Access.MARKET_COMPOSITION,
                ...Access.MARKET_SELECTION,
              }}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.MARKETCOMPOSITION}
              component={MarketComposition}
              routePermissions={Access.MARKET_COMPOSITION}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.MARKETCOMPOSITIONOLD}
              component={marketCompositionOld}
              routePermissions={Access.MARKET_COMPOSITION}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.MARKETCOMPOSITIONUPDATEDSCHEDULE}
              component={MarketComposition}
              routePermissions={Access.MARKET_COMPOSITION}
            />

            <PrivateRoute
              routePermissions={Access.SCHEDULE}
              isAuthenticated={authState.status}
              path={Routes.SCHEDULEEXIBITIONUPDATEDSCHEDULE}
              component={ScheduleExibition}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.MRCCOMPLEMENTARY} component={MrcComplementaryInformation} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SENDMRCREQUEST} component={SendMrcRequest} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.DOCUMENTMANAGEMENT} component={DocumentManagement} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.APPROVEDNBI} component={ApprovedNbi} />

            <PrivateRoute
              routePermissions={{
                ...Access.APPROVE_REJECT_POLICY_PACK,
                ...Access.ENDORSEMENTS,
              }}
              isAuthenticated={authState.status}
              path={Routes.APPROVALPOLICYPACK}
              component={ApprovalPolicyPack}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENDAPPROVALPOLICYPACK}
              component={SendApprovalPolicyPack}
              routePermissions={{
                ...Access.APPROVE_REJECT_POLICY_PACK,
                ...Access.ENDORSEMENTS,
              }}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENDPOLICYPACKINSURER}
              component={SendPolicyPackInsurer}
              routePermissions={{
                ...Access.APPROVE_REJECT_POLICY_PACK,
                ...Access.ENDORSEMENTS,
              }}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENDORDERTOBIND}
              component={SendOrderToBind}
              routePermissions={Access.ORDER_TO_BIND}
            />

            <PrivateRoute
              routePermissions={Access.ORDER_TO_BIND}
              isAuthenticated={authState.status}
              path={Routes.ORDERTOBIND}
              component={OrderToBind}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.PAYMENTCONFIGURATION}
              component={PaymentConfiguration}
              routePermissions={Access.PAYMENT_PACK}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENDINVOICE}
              component={SendInvoice}
              routePermissions={Access.PAYMENT_PACK}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SENDPOLICYPACKDIRECTORAPPROVAL} component={SendPolicyPackDirectorApproval} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SENDPOLICYPACKDIRECTOR} component={SendPolicyPackDirector} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.POLICYPACKDIRECTORAPPROVAL} component={PolicyPackDirectorApproval} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SENDINVOICENOTPREAGREED} component={SendInvoiceNotPreAgreed} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.APPROVALINVOICE}
              component={ApprovalInvoice}
              routePermissions={{
                ...Access.PAYMENT_PACK,
                ...Access.MARKET_COMPOSITION,
              }}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.APPROVALINVOICENOTPREAGREED}
              component={ApprovalInvoiceNotPreAgreed}
              routePermissions={{
                ...Access.ENDORSEMENTS,
                ...Access.PAYMENT_PACK,
                ...Access.MARKET_COMPOSITION,
              }}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENT_TO_XIS}
              component={SentToXis}
              routePermissions={{
                ...Access.PAYMENT_PACK
              }}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.NBIREQUEST} component={NbiRequest} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.NBIREQUESTCLIENT}
              component={NbiRequestCv}
              routePermissions={Access.APPROVAL_NBI}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.SENDPOLICYPACKCLIENT}
              component={SendPolicyPackClient}
              routePermissions={{
                ...Access.APPROVE_REJECT_POLICY_PACK,
                ...Access.ENDORSEMENTS,
              }}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SENDNBI} component={SendNbi} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CONTACTSSELECTION} component={ContactSelection} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CONTACTSSELECTIONNOTPREAGREED} component={ContactSelectionNotPreAgreed} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CREATEENQUIRITY} component={EditEnquirity} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.EDITENQUIRITY} component={EditEnquirity} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.ENQUIRIES}
              component={ListPage2}
              routePermissions={Access.ENQUIRY}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.LIST}
              component={ListPage2}
              routePermissions={Access.ENQUIRY}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.LIST2}
              component={ListPage2}
              routePermissions={Access.ENQUIRY}
            />

            <PrivateRoute isAuthenticated={authState.status} path={QuotationRoutes.EDIT} component={QuoteEditPageV2} />

            <PrivateRoute isAuthenticated={authState.status} path={QuotationRoutes.ADD} component={QuoteAddPage} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.STAMPSREQUESTCONTACTS}
              component={StampRequestContacts}
              routePermissions={Access.STAMPS_REQUEST}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SENDENDORSEMENTOFFRISK} component={SendEndorsementOffRisk} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.ENDORSEMENTNOTPREAGREED} component={EndorsementNotPreAgreed} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.ENDORSEMENTCANCELLATION} component={EndorsementNotPreAgreed} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.ENDORSEMENTOFFRISK} component={EndorsementNotPreAgreed} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.ENDORSEMENTPOLICYEXTENSION} component={EndorsementNotPreAgreed} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.ENDORSEMENTADJUSTMENTANDCORRECTIONS} component={EndorsementNotPreAgreed} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.ENDORSEMENTMARKETCHANGES} component={EndorsementNotPreAgreed} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.ENDORSEMENTCLIENTCHANGE} component={EndorsementNotPreAgreed} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.APPROVALENDORSEMENTOFFRISK}
              component={ApprovalEndorsementOffRisk}
              routePermissions={{
                ...Access.ENDORSEMENTS,
                ...Access.STAMPS_REQUEST,
              }}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CONTACTSSELECTIONENDORSEMENTOFFRISK} component={EndorsementOffRiskContactsSelection} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.BOUNDENDORSEMENTOFFRISK} component={BoundEndorsementOffRisk} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.BOUNDENDORSEMENTPOLICYEXTENSION} component={BoundEndorsementPolicyExtension} />

            {/*****  BASE ROUTES *****/}
            <PrivateRoute isAuthenticated={authState.status} path={Routes.HOME} component={HomePage} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.POLICIES}
              component={PolicyPage}
              routePermissions={Access.POLICIES}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CLAIMS} component={ClaimPage} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CREATECLAIM} component={EditClaim} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.EDITCLAIM} component={EditClaim} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CLAIM_COMPOSITION} component={ClaimComposition} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.CLAIM_FDO} component={ClaimFDO} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.RENEWALS} component={RenewPage} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.TEST1} component={Test1Page} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.TEST2} component={Test2Page} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.PAYMENTS}
              component={PaymentPageV2}
              routePermissions={Access.PAYMENTS}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.RENEWALS} component={RenewPage} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.SCHEDULEEXPORT} component={ScheduleInitialExport} />

            <PrivateRoute
              routePermissions={Access.SCHEDULE}
              isAuthenticated={authState.status}
              path={Routes.SCHEDULEEXIBITION}
              component={ScheduleExibition}
            />

            <PrivateRoute
              routePermissions={{
                ...Access.APPROVE_REJECT_POLICY_PACK,
                ...Access.ENDORSEMENTS,
                ...Access.ORDER_TO_BIND,
              }}
              isAuthenticated={authState.status}
              path={Routes.POLICYPACKAAPPROVALLIST}
              component={PolicyPackApprovalList}
            />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.MANAGEMENT_PERSON} component={editPerson} />

            <PrivateRoute isAuthenticated={authState.status} path={Routes.MANAGEMENT} component={ManagementPage} />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.CONTRACT_BUILDER}
              component={ContractBuilder}
              routePermissions={Access.MARKET_COMPOSITION}
            />

            {false && <PrivateRoute isAuthenticated={authState.status} path={Routes.TEST2} component={Test2Page} />}

            <PrivateRoute path={Routes.MANAGEMENT} component={ManagementPage} />

            <PrivateRoute path={Routes.PRODUCT_PLAN_PERSON} component={ProductPlanPerson} />

            <PrivateRoute path={Routes.EDIT_PRODUCT_PLAN} component={EditProductPlan} />

            <PrivateRoute path={Routes.PRODUCTS} component={Products} />

            <PrivateRoute path={Routes.EDIT_PRODUCT} component={EditProduct} />

            <PrivateRoute path={Routes.IMPORT_CURRENCY_RATE} component={ImportCurrencyRate} />

            {false && <Route path={Routes.TEST2} component={Test2Page} />}

            {/*****  PROCESS ADMIN ROUTES *****/}
            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.PROCESS_ADMIN_PERSON}
              component={ProcessAdminPerson}
            />

            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.PROCESS_ADMIN} component={ProcessAdmin}
              routePermissions={{
                ...Access.MARKET_COMPOSITION,
                ...Access.PROCESS_ADMIN,
                ...Access.MANAGEMENT,
              }}
            />

            <Redirect to={authState.status ? Routes.HOME : Routes.LOGIN} />

          </Switch>
        </Router>
      </ReportExportService>
      <GlobalAuthContext.Provider value={authState} />
    </GlobalLoaderContext.Provider>
  );
};

export default App;
